export enum ANALYTICS_TYPES {
  USER = 'USER',
  CUSTOMER = 'CUSTOMER',
  OLIASOFT = 'OLIASOFT',
}